export class SessionModel {
    _id?: any;
    uuid: string;
    conversation_uuid: string;
    start_date: Date;
    last_update_date: Date;
    timeout: boolean;
    expiry_date?: boolean;
    created_by: string;
    updated_by: string;
    revision?: string;
    status?: string;
    vrsn?: string;
    task_guid?: string;
    conversation_state?: string;
}
